export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_darakmana.png",
      alt: "Nome da extensão",
    },
    title: "Se você procura resultados consistentes, opere com as automações da Darakmana",
    text: [
      "No mundo dos investimentos, minimizar riscos sem comprometer a rentabilidade é um dos maiores desafios. É exatamente isso que nossos métodos operacionais fazem para você. Utilizando estratégias avançadas a mais de 6 anos, essa abordagem protege o capital contra oscilações de mercado, garantindo maior previsibilidade e segurança para o investidor. Faça parte da nova geração de traders vencedores que operam através de automações e tenha mais tempo livre para sua família e seus negócios.",
    ],
    testimonial: {
      text: "Algo GRANDE está chegando. Você não vai querer ficar de fora!",
      author: {
        name: "Raphael Q., CEO Darakmana Soluções em Tecnologia",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "O que os números dizem sobre nós",
    subtitle: "Operamos a mais de 6 anos o mercado, com resultados consistentes",
    data: [
      {
        value: "+6",
        description: "Anos de experiencia",
      },
      {
        value: "+3",
        description: "Anos operando estratégias automatizadas",
      },
      {
        value: "+10000",
        description: "Horas de Backtestes",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Darakmana?",
    subtitle: "Veja quais as principais vantagens dos robôs da Darakmana.",
    data: [
      {
        title: "Velocidade e Precisão",
        description:
          "Robôs tomam decisões em milissegundos, aproveitando as melhores chances antes que o mercado mude.",
      },
      {
        title: "Eliminação de Erros Emocionais",
        description: "Eles operam com base em lógica, eliminando o impacto das emoções nas decisões financeiras.",
      },
      {
        title: "Diversificação e Personalização",
        description:
          "Você pode programar estratégias que se adaptam ao seu perfil de risco, diversificando investimentos de maneira inteligente.",
      },
      {
        title: "100% automatizado",
        description: "Você só precisa apertar o play e eles fazem todo o trabalho por você.",
      },
      {
        title: "Baixa Frequência de Operações",
        description: "As estratégias realizam poucas operações ao longo do dia (máximo de 2 por automação).",
      },
      {
        title: "Consistência de Resultados",
        description: "Estratégias automatizadas, testadas e validadas com consistência de mais de 6 anos de mercado.",
      },
    ],
  },
  cta: {
    title: "Preparado para iniciar sua jornada pela consistência?",
    subtitle: "Junte-se a nós, agora mesmo!",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Darakmana",
    col1: [
      "Com mais de 6 anos de experiência no mercado financeiro, a Darakmana construiu um histórico sólido de resultados consistentes. Agora, decidimos tornar nossas estratégias acessíveis ao público em geral, compartilhando nosso conhecimento e expertise.",
      "Nossas operações automatizadas permitem que os investidores otimizem seu tempo, sem a necessidade de acompanhar o mercado o tempo todo, podendo aproveitar esse tempo de outras formas.",
    ],
    col2: [
      "Além disso, a automação elimina o fator emocional das decisões, garantindo operações mais estratégicas e racionais. Estamos sempre em busca de inovação, acompanhando as tendências e evoluções do mercado para oferecer soluções cada vez mais avançadas e eficazes. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Darakmana",
  },
  strategies: {
    title: "Estratégias Darakmana",
    heading: "Estratégias desenvolvidas por Trader de verdade",
    subtitle:
      "Nossas estratégias são a ferramenta que você precisa para virar o jogo! Operações automatizadas, sem emoções e com resultados comprovados.",
  },
};
